import React from 'react';

const Operator = ({operator}) => (
    <>
        <span className="operator ml-1 mr-1">{operator}</span>
    </>
);

export default Operator;
